import moment from 'moment'

export const profileArray = [
  { name: 'medical', permission: 'patientMedical' },
  { name: 'clinical', permission: 'patientClinicalTests' },
  { name: 'chart', permission: 'getPatientOperations' },
  { name: 'xrays', permission: 'patientXrays' },
  { name: 'invoices', permission: 'invoices' },
  { name: 'payments', permission: 'payments' }
]

export const statusArray = [
  {
    name: 'OPEN',
    color: 'blue',
    colorHex: '#1890ff',
    backgroundColor: '#e6f7ff',
    borderColor: '#53a3ec',
    dark: '#15abd8',
    darkBorder: '#0b597e',
    newColor: '#140fba'
  },
  {
    name: 'CONFIRMED',
    color: 'geekblue',
    colorHex: '#031fa6',
    backgroundColor: '#f0f5ff',
    borderColor: '#3365d7',
    dark: '#153e94',
    darkBorder: '#082054',
    newColor: '#040262'
  },
  {
    name: 'CHECKEDIN',
    color: 'cyan',
    colorHex: '#13c2c2',
    backgroundColor: '#e6fffb',
    borderColor: '#50f1e2',
    dark: '#20bea6',
    darkBorder: '#06695a',
    newColor: '#01e4cb'
  },
  {
    name: 'INPROGRESS',
    color: 'purple',
    colorHex: '#722ed1',
    backgroundColor: '#f9f0ff',
    borderColor: '#a04def',
    dark: '#681c9a',
    darkBorder: '#32064f',
    newColor: '#8206b3'
  },
  {
    name: 'COMPLETED',
    color: 'green',
    colorHex: '#60d028',
    backgroundColor: '#f6ffed',
    borderColor: '#91ee4a',
    dark: '#166534',
    darkBorder: '#05410a',
    newColor: '#0a7a01'
  },
  {
    name: 'DELAYED',
    color: 'orange',
    colorHex: '#fa8c16',
    backgroundColor: '#fff7e6',
    borderColor: '#f1b34f',
    dark: '#ff8605',
    darkBorder: '#914e0a',
    newColor: '#ff8605'
  },
  {
    name: 'CANCELED',
    color: 'magenta',
    colorHex: '#eb2fd8',
    backgroundColor: '#fff0f6',
    borderColor: '#ef54d5',
    dark: '#c41c80',
    darkBorder: '#810f53',
    newColor: ''
  },
  {
    name: 'NOSHOW',
    color: 'red',
    colorHex: '#cf1322',
    backgroundColor: '#fff1f0',
    borderColor: '#ef817b',
    dark: '#640f09',
    darkBorder: '#3f0905',
    newColor: '#fe0100'
  },
  {
    name: 'WAITING',
    color: 'yellow',
    colorHex: '#d4b106',
    backgroundColor: '#feffe6',
    borderColor: '#fffb8f',
    dark: '#b1b71a',
    darkBorder: '#737905',
    newColor: '#f3fe05'
  },
  {
    name: 'NOTE',
    color: '',
    colorHex: '#868686',
    backgroundColor: '#fafafa',
    borderColor: '#afafaf',
    dark: '#868686',
    darkBorder: '#414141',
    newColor: '#444444'
  }
]

export const formats = {
  agendaHeaderFormat: (date, culture, localizer) => localizer.format(date.start, 'dddd, DD MMMM YYYY', culture),
  dayHeaderFormat: (date, culture, localizer) => localizer.format(date, 'dddd, DD MMMM YYYY', culture),
  dayRangeHeaderFormat: (date, culture, localizer) => {
    if (moment(date.start).month() === moment(date.end).month()) {
      return `${localizer.format(date.start, 'DD', culture)}
    -
    ${localizer.format(date.end, 'DD', culture)} ${localizer.format(date.end, 'MMM', culture)}`
    }
    return `${localizer.format(date.start, 'DD MMM', culture)}
    -
    ${localizer.format(date.end, 'DD MMM', culture)}`
  },
  eventTimeRangeFormat: () => null,
  dayFormat: (date, culture, localizer) => localizer.format(date, 'dddd DD', culture),
  weekdayFormat: (date, culture, localizer) => localizer.format(date, 'dddd', culture),
  timeGutterFormat: (date, culture, localizer) => localizer.format(date, 'hh:mm a', culture)
}

/**
 * The length an appointment type books, in minutes, and whether it is locked to it; null for a type that sets none
 * @param {string|object[]} appointmentTypes the company's types, as saved or parsed
 * @param {string} type the type's enum
 */
export const getAppointmentTypeDuration = (appointmentTypes, type) => {
  let types = []
  try {
    types = (typeof appointmentTypes === 'string' ? JSON.parse(appointmentTypes) : appointmentTypes) || []
  } catch (e) {}
  const item = types.find(s => s.enum === type)
  return item?.duration ? { duration: item.duration, locked: !!item.lockDuration } : null
}

/** Where an appointment starting at `start` (a moment) ends after `duration` minutes, kept within its day */
export const getAppointmentTypeEnd = (start, duration) => {
  const end = start.clone().add(duration, 'minutes')
  return end.isSame(start, 'day') ? end : start.clone().endOf('day').startOf('minute')
}
